import { render, staticRenderFns } from "./stats.sales.vue?vue&type=template&id=f6dc99e0&"
import script from "./stats.sales.vue?vue&type=script&lang=js&"
export * from "./stats.sales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports